export default {
    user(state){
        let temp = state.user
        return temp ? temp : null
    },
    imgs(state){
        let temp = state.imgs
        return temp ? temp : []
    },
    user_files(state){
        let temp = state.user_files

        if(temp['casting/foto']){

            for (const [key, value] of Object.entries(temp['casting/foto'])) {
                temp['casting/foto'][key].name = value.name + "?" + new Date().getTime()
            }

            if (temp['casting/foto'].docs) {
                temp['casting/foto'].docs.forEach(element => {
                    element.name = element.name + "?" + new Date().getTime()
                })
            }

            // temp['casting/foto'].forEach(element => {
            //     element.url = element.url + "?" + new Date().getTime()
            // });
        }

        return temp ? temp : null
    },
};